/* eslint-disable @typescript-eslint/no-require-imports */
import { Platform } from 'react-native';

const SupportScreen =
  Platform.OS === 'web' ? require('./support.web').default : require('./support.native').default;

export default SupportScreen;
